import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { buildCookie } from '@/modules/cdn/cookie'
import { ApiTaCt010 } from '~/endpoints/ApiTaCt010'

interface AkamaiTokenData {
  akamaiToken: string
}
const getEmptyAkamaiToken = (): AkamaiTokenData => ({
  akamaiToken: '',
})

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/AkamaiToken',
})
export default class AkamaiToken extends VuexModule {
  // States
  private akamaiToken_ = getEmptyAkamaiToken()

  // Getters
  get akamaiCookie(): (expiresAt?: string) => string {
    return (expiresAt?: string) => buildCookie(this.akamaiToken_.akamaiToken, expiresAt)
  }

  // Mutations
  @Mutation
  updateAkamaiToken(value: AkamaiTokenData) {
    this.akamaiToken_ = value
  }

  // Actions

  @Action
  clear() {
    this.context.commit('updateAkamaiToken', getEmptyAkamaiToken())
  }

  @Action
  async getAkamaiToken() {
    logger.trace('in: getAkamaiToken')
    const api = new ApiTaCt010.Api()

    // API: ApiTaCt010
    const result = await api.get<AkamaiTokenData | null>(
      {},
      // success
      (data, _) => {
        return {
          akamaiToken: data.akamaiToken,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateAkamaiToken', result)
  }
}
